// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {errorAlertBar} from '../../../shared/services/alert-bar';
import {validateAttachmentItemNumber} from '../../shared/repositories';

export const validateItemNumber = itemNumber =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const response = await validateAttachmentItemNumber(itemNumber);

            if (!response.isValidItem) {

                const error = {
                    isTranslated: true,
                    message: response.message.text
                };

                errorAlertBar(error);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/attachment/action-creators/validate-item-number.js